module.exports = __webpack_public_path__ + "static/media/car-crash-solid.8da7aebc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/assets/car-crash-solid.svg
// module id = 1972
// module chunks = 0